import { z } from 'zod';
import { UserType } from '../../../api/users/users.contracts';
import { Permission } from '@/modules/users/submodules/roles/api/permissions.contracts';

const BaseUserFormSchema = z.object({
  name: z.string(),
  email: z.string().min(1, { message: 'this_field_has_to_be_filled' }).email('this_is_not_a_valid_email'),
  type: z.nativeEnum(UserType).optional(),
  isActive: z.boolean().optional(),
  roleIds: z.array(z.number()),
  locationIds: z.array(z.number()).optional(),
  permissions: z.array(z.nativeEnum(Permission)).optional(),
  // Password is optional during edits
  password: z.string().optional(),
});

export const UserFormSchema = BaseUserFormSchema.refine(
  (data) => {
    // If user type is GUEST, roleIds can be empty (will be filled automatically)
    if (data.type === UserType.GUEST) {
      return true;
    }
    // For other types, roleIds must have at least one item
    return data.roleIds && data.roleIds.length > 0;
  },
  {
    message: 'you_must_select_a_role',
    path: ['roleIds'], // This will show the error on the roleIds field
  },
);

// Make password a required field during create
export const UserCreateFormSchema = BaseUserFormSchema.extend({
  // Firebase requires at least 6 characters password
  password: z.string().min(6, {
    message: 'password_with_minimum_characters_required',
  }),
}).refine(
  (data) => {
    // If user type is GUEST, roleIds can be empty (will be filled automatically)
    if (data.type === UserType.GUEST) {
      return true;
    }
    // For other types, roleIds must have at least one item
    return data.roleIds && data.roleIds.length > 0;
  },
  {
    message: 'you_must_select_a_role',
    path: ['roleIds'],
  },
);

export type UserFormModel = z.infer<typeof UserFormSchema>;
